import Swiper from 'swiper/core';

export default class Reviews {
  constructor(swiper, thumbs) {
    this.dom = {
      swiper,
      thumbs,
    };

    this.components = {
      thumbsSwiper: null,
      mainSwiper: null,
    };

    this.mount();
  }

  mount() {
    this.initThumbs();
    this.initMainSwiper();
  }

  initThumbs() {
    this.components.thumbsSwiper = new Swiper(this.dom.thumbs, {
      loop: false,
      freeMode: false,
      slidesPerView: 1,
      effect: 'fade',
      watchSlidesProgress: true,
      allowTouchMove: false,
      slideToClickedSlide: false,
      simulateTouch: false,
      touchRatio: 0,
    });
  }

  initMainSwiper() {
    this.components.mainSwiper = new Swiper(this.dom.swiper, {
      loop: false,
      rewind: true,
      spaceBetween: 30,
      speed: 1500,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: this.components.thumbsSwiper,
      },
    });
  }
}
